import firebase from "firebase/compat/app";
import "firebase/compat/database";
import "firebase/compat/firestore";
import "firebase/compat/storage";
import "firebase/compat/auth";
import "firebase/compat/functions";
import { getVar } from "config";
import logger from "../../logging/logger";
import { Actions, trackAction } from "../../modules/monitoring";

const firebaseConfig = {
  apiKey: getVar("REACT_APP_FIREBASE_API_KEY"),
  authDomain: getVar("REACT_APP_FIREBASE_AUTH_DOMAIN"),
  databaseURL: getVar("REACT_APP_FIREBASE_DB_URL"),
  projectId: getVar("REACT_APP_FIREBASE_PROJECT_ID"),
  storageBucket: getVar("REACT_APP_FIREBASE_STORAGE_BUCKET"),
  messagingSenderId: getVar("REACT_APP_FIREBASE_ID"),
};

firebase.initializeApp(firebaseConfig);

const firestore = firebase.firestore();
const database = firebase.database();
const storage = firebase.storage();

firebase.onLog(
  ({ type, message }) => {
    if (
      type === "@firebase/firestore" &&
      message.toLowerCase().includes("connection")
    ) {
      trackAction(Actions.FIRESTORE_CONNECTION_ERROR);
    }
  },
  {
    level: "warn",
  },
);

const signOutFirebase = async () => {
  try {
    logger.info("[FirebaseService][signOutFirebase] Sign out firebase.");
    await firebase.auth().signOut();
  } catch (error) {
    const errorMessage = error instanceof Error ? error.message : "";
    logger.error(
      `[FirebaseService][signOutFirebase] Fail to sign out firebase. Reason: ${errorMessage}`,
    );
  }
};

const serverValue = firebase.database.ServerValue;
const fieldValue = firebase.firestore.FieldValue;

export const getFirebaseUID = () => {
  const { currentUser } = firebase.auth();

  return currentUser ? currentUser.uid : null;
};

export const initAuthToken = (): Promise<string> => {
  logger.info("[FirebaseService][initAuthToken] Init auth token.");

  return new Promise((resolve, reject) => {
    firebase.auth().onAuthStateChanged((user) => {
      if (user) {
        user
          .getIdToken()
          // eslint-disable-next-line promise/prefer-await-to-then,  promise/always-return
          .then((idToken) => {
            resolve(idToken);
          })
          // eslint-disable-next-line promise/prefer-await-to-then
          .catch((err) => {
            logger.error(
              `[FirebaseService][initAuthToken] Fail to get IdToken. Reason: ${err.message}`,
            );
            reject(err);
          });
      } else {
        logger.warn(
          "[FirebaseService][initAuthToken] Fail to initAuthToken. Reason: User not found",
        );
        reject(new Error("User not found."));
      }
    });
  });
};

export {
  firebaseConfig,
  firebase,
  firestore,
  database,
  storage,
  signOutFirebase,
  serverValue,
  fieldValue,
};
